/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PipelineEntityFilterMode = typeof PipelineEntityFilterMode[keyof typeof PipelineEntityFilterMode];


export const PipelineEntityFilterMode = {
  include: 'include',
  exclude: 'exclude',
} as const;
